import axios from "axios";
import { toast } from "react-toastify";
import { clearStorage, getToken, setToken } from "../utils/localStorage";

const createAxios = (baseURL) => {
  const Axios = axios.create({ baseURL });

  Axios.interceptors.response.use(
    async (response) => {
      return response.data;
    },
    async (error) => {
      let originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        // if the error is 401 and hasent already been retried
        originalRequest._retry = true; // now it can be retried
        try {
          const token = getToken();
          Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          return Axios(originalRequest);
        } catch (error) {
          if (error.response.status === 401) {
            // logout dispatch
            toast("Session Expired");
            clearStorage();
          }
        }
      }
      return error.response.data;
    }
  );

  Axios.interceptors.request.use(
    async (config) => {
      const token = getToken();
      if (token) {
        config.headers = {
          Authorization: `Bearer ${token}`,
        };
      }
      return config;
    },
    (error) => {
      return Promise.reject(error.response.data);
    }
  );

  return Axios;
};

// Base Url
const apiurl = createAxios(
  // "http://localhost:8080/api/v1/"
 //  "https://pqrw9d9b6h.us-east-1.awsapprunner.com/api/v1" --- paused oct 27th 2025 and used cname
  "https://kvqaksd6fv.us-east-1.awsapprunner.com/api/v1/"
  // "https://apis.milestone101.com/api/v1/"
  // "https://ec2-35-172-219-149.compute-1.amazonaws.com:8443/api/v1/" // production
);

const http = {
  apiurl,
};

export default http;
